import { render, staticRenderFns } from "./Restaurants.vue?vue&type=template&id=23fe7144"
import script from "./Restaurants.vue?vue&type=script&lang=js"
export * from "./Restaurants.vue?vue&type=script&lang=js"
import style0 from "./Restaurants.vue?vue&type=style&index=0&id=23fe7144&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports